<div class="password-dialog">
  <div class="icon-container">
    <img src="assets/icon/input-pin.svg" alt="Input Password" class="password-icon" />
  </div>

  <div class="content">
    <h2 class="title">Input Password</h2>
    <p class="subtitle">Please enter your current password</p>

    <form [formGroup]="passwordForm" (ngSubmit)="onSubmitNewPassword()">
      <div class="input-group">
        <div class="label-row">
          <label for="re-enter-password" class="input-label"
            >Password <span class="required">*</span></label
          >
        </div>
        <div class="input-wrapper">
          <input
            [type]="inputType.password"
            name="password"
            id="re-enter-password"
            placeholder="Input password here"
            autocomplete="off"
            formControlName="password"
            class="password-input"
          />
          <i
            [class]="inputType.password === 'password' ? 'pi pi-eye' : 'pi pi-eye-slash'"
            class="input-icon"
            (click)="toggleInputType('password')"
          ></i>
        </div>
      </div>

      <div class="error-messages">
        <div *ngIf="error() !== ''" class="error-message">
          <i class="pi pi-exclamation-triangle"></i> {{ error() }}
        </div>
      </div>

      <div class="button-group">
        <lib-button type="Secondary" (click)="onCancel()" label="Cancel" width="120px"></lib-button>
        <lib-button
          type="Primary"
          [disabled]="!passwordForm.get('password')?.value"
          (click)="onSubmitNewPassword()"
          label="Next"
          width="120px"
        ></lib-button>
      </div>
    </form>
  </div>
</div>
